import {
    listRequest,
    listResponse,
    listCachedResponse,
    listErrorResponse
} from "./default-actions/paging-actions"
import {
    PROJECT_LIST_REQUEST,
    PROJECT_LIST_RESPONSE,
    PROJECT_LIST_CACHED_RESPONSE,
    PROJECT_LIST_ERROR_RESPONSE
} from "./action-types"

// Project Paging Actions
export const projectListRequest = listRequest(PROJECT_LIST_REQUEST)
export const projectListResponse = listResponse(PROJECT_LIST_RESPONSE)
export const projectListCachedResponse = listCachedResponse(
    PROJECT_LIST_CACHED_RESPONSE
)
export const projectListErrorResponse = listErrorResponse(
    PROJECT_LIST_ERROR_RESPONSE
)
